import { LocaleHome } from '../en/home'

const home: LocaleHome = {
  pickleballGlobal: 'Sistem Penarafan Global Pickleball yang Paling Tepat',
  freePlayers: 'Percuma untuk Semua Pemain',
  trustedByTheWorld:
    'Dipercayai oleh kelab Pickleball terunggul di dunia, tur profesional, dan pemain rekreasi sekalipun.',
  ourPhilosophy: 'Falsafah Kami',
  innovateGame: 'Inovasi permainan.',
  unifySport: 'Satukan sukan.',
  theMostAccurateGlobal:
    'Sistem penarafan global yang paling tepat yang dipercayai oleh kelab-kelab Pickleball terunggul, tur, dan profesional di dunia.',
  optimizedAccuracy: 'Dioptimumkan untuk Ketepatan',
  yourDUPRRating: 'Penarafan DUPR anda dikira oleh',
  marginVictory: 'Margin Kemenangan',
  pointsWon: '(mata yang dimenangi)',
  typeResult: 'Jenis Keputusan',
  recreationalEtc: '(permainan rekreasi vs. liga, kejohanan yang disahkan, dan lain-lain)',
  outcome: 'Keputusan',
  winLoss: '(menang atau kalah)',
  builtPickleball: 'Dibina untuk Komuniti Pickleball',
  builtPickleballDesc:
    'Satu komuniti yang berpandangan ke hadapan dan inklusif layak mendapat penarafan yang setara. Dengan DUPR, semua pemain tanpa mengira umur, jantina, lokasi, atau kemahiran dinilai pada skala yang sama antara 2.00-8.00.',
  whatWeDo: 'Apa yang kami lakukan',
  aNewWayPlay: 'Cara Baru untuk Bermain',
  aNewWayPlayDesc:
    'Sistem penarafan DUPR tidak kehilangan sebarang maklumat atau data. Mereka menggabungkan segala-galanya ke dalam algoritma mereka, menjadikannya yang paling tepat',
  searchTheDatabase: 'Cari Pangkalan Data',
  searchTheDatabaseDesc: 'Semak pangkalan data DUPR yang mengandungi lebih daripada 1,000,000 pemain pickleball.',
  findYourClub: 'Cari Kelab Anda',
  findYourClubDesc: 'Ikuti kelab anda untuk mendapatkan kemas kini mengenai acara akan datang.',
  analyzePerformance: 'Analisis Prestasi Anda',
  analyzePerformanceDesc: 'Jejaki kemajuan anda menyusuli analisis DUPR terhadap permainan anda.',
  logMatches: 'Rekod Perlawanan',
  logMatchesDesc: 'Masukkan markah dari setiap perlawanan, bila-bila masa. ',
  connectLocalPlayers: 'Sambungkan dengan Pemain Tempatan',
  connectLocalPlayersDesc: 'Cari pemain tempatan dan aturkan permainan. ',
  events: 'Acara',
  eventsDesc: 'Uji kemahiran anda menentang lawan yang setara dalam acara bertanda DUPR.',
}

export default home
